import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ClientSignup from './ClientSignup/ClientSignup';
import AdminInformation from './AdminInformation/AdminInformation';
import Options from './Options/Options';
import Disclaimer from './Disclaimer/Disclaimer';
import Message from '../Common/Message/Message';
import './Registration.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
class Registration extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            register: {
                business: {
                    client_name: '',
                    client_email: '',
                    client_phone: '',
                    billing_contact: '',
                    billing_address_1: '',
                    billing_address_2: '',
                    billing_city: '',
                    billing_state: 'AL',
                    billing_zip: '',
                    billing_country: 'US',
                    donation: true,
                    donation_email: 'Thank you so much for your donation! Keep a copy of this email and your credit card statement to show that you have made a charitable contribution. Your donation is very much appreciated.',
                    referred_by: '',
                    donation_message: 'Please consider making a tax deductible donation. Your financial support is not only needed, but is greatly appreciated and instrumental in producing quality entertainment.',
                    collect_cust_info: false,
                    allow_will_call: true,
                    allow_callcenter_refund: true,
                    allow_callcenter_exchange: false
                },
                admin: {
                    username: '',
                    password: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    facebook_access_token: '',
                    google_id_token: '',
                    id: undefined,
                    login_type: 'password'
                }
            },
            validation: {
                business: {
                    client_name: {
                        valid: null,
                        msg: ''
                    },
                    billing_address_1: {
                        valid: null,
                        msg: ''
                    },
                    client_email: {
                        valid: null,
                        msg: ''
                    },
                    client_phone: {
                        valid: null,
                        msg: ''
                    },
                    billing_city: {
                        valid: null,
                        msg: ''
                    },
                    billing_country: {
                        valid: true,
                        msg: ''
                    },
                    billing_state: {
                        valid: true,
                        msg: ''
                    },
                    billing_contact: {
                        valid: null,
                        msg: ''
                    },
                    billing_zip: {
                        valid: null,
                        msg: ''
                    }
                },
                admin: {
                    username: {
                        valid: null,
                        msg: ''
                    },
                    password: {
                        valid: null,
                        msg: ''
                    },
                    first_name: {
                        valid: null,
                        msg: ''
                    },
                    last_name: {
                        valid: null,
                        msg: ''
                    },
                    email: {
                        valid: null,
                        msg: ''
                    }
                }
            },
            isReadyToSubmit : false,
            googleButtonFaded: false,
            message: {
                title: '',
                content: '',
                type: ''
            }
        };
    }

    postUser = () => {
        this.setMessage('','','loading');
        const data = {...this.state.register};

        (async () => {
            try {
                const clientSignupResponse = await clientSignup(data);
                console.log('Client signup Response: ', clientSignupResponse);
                if(clientSignupResponse.data.error === undefined){
                    this.setMessage(window.general_strings.msg.yay,strings.msg.success,'success');

                    setTimeout(async() => {
                        const clientStatusResponse = await getAuthStatus();
                        console.log('Client logged status Response: ', clientStatusResponse);
                        if(clientStatusResponse.data.authenticated){
                            this.props.userLogin(clientStatusResponse.data, '/event');
                        }
                    }, 2000);
                } else {
                    if (clientSignupResponse.data.error.details) {	
                        let errorString = '';	
                        clientSignupResponse.data.error.details.forEach((detail) => {	
                            errorString += `${detail.field}: ${detail.message} <br />`;	
                        });
                        this.setMessage(window.general_strings.msg.oops,errorString,'error');	
                    } else {	
                        this.setMessage(window.general_strings.msg.oops,clientSignupResponse.data.error.code,'error');	
                    }
                }
                window.scrollTo(0, 0);
            } catch (error) {
                console.log(error);
            }
        })()

        async function clientSignup(data) {
            return await ApiRequest('/clients/signup', {
                method: 'post',
                data: {
                    client: data.business,
                    login_type: data.admin.login_type,
                    user: data.admin
                }
            });
        }

        async function getAuthStatus() {
            return await ApiRequest('/auth/status');
        }

    }

    handleChange = (e) => {
        e.persist();
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        const register = {...this.state.register};
        if (name === 'country') {
            this.state.register.business.country === 'US' ? register[key]['state'] = 'AL' : register[key]['state'] = 'AB'
        }
        register[key][name] = value;
        this.setState({ register });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e);
        }
        this.validateAllRequiredFields();
    }

    validate = (value, key, name, validationRegEx, e) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[key][name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[key][name]['valid'] = isValid;
        this.setState({ validation }, () => { this.validateRequiredField(e) });
    }

    validateRequiredField = (e) => {
        const validation = { ...this.state.validation };
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const key = e.target.attributes.getNamedItem('object').value;
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[key][name]['msg'] = strings.errorRequired;
            validation[key][name]['valid'] = false;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    getSum = (total, num) => {
        return total + num;
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.map((i) => { 
            return Object.keys(i).map((k) => i[k]);
        })
        .map((i) => { 
            return i.filter((l) => { 
                return typeof(l.valid) !== 'undefined'; 
            }).length; 
        })
        .reduce(this.getSum);
        for (let type in validation) {
            for (let field in validation[type]) {
                if (validation[type][field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    updateValidation = () => {
        const validation = { ...this.state.validation };
        const socialMediaFields = ['email', 'first_name', 'last_name'];
        socialMediaFields.forEach(field => {
            validation['admin'][field]['valid'] = true;
        });
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    facebookCallback = (response) => {
        const nameArray = response.name.split(' ');
        const register = { ...this.state.register };
        register['admin']['email'] = response.email;
        register['admin']['first_name'] = nameArray[0];
        register['admin']['last_name'] = nameArray[1];
        register['admin']['facebook_access_token'] = response.accessToken;
        register['admin']['login_type'] = 'facebook';
        register['admin']['id'] = parseInt(response.id, 0);
        this.setState({ register });
        this.updateValidation();
    }

    googleCallback = (response) => {
        const register = { ...this.state.register };
        register['admin']['email'] = response.profileObj.email;
        register['admin']['first_name'] = response.profileObj.givenName;
        register['admin']['last_name'] = response.profileObj.familyName;
        register['admin']['google_id_token'] = response.tokenId;
        console.log('google response: ', response);
        register['admin']['login_type'] = 'google';
        register['admin']['id'] = parseInt(response.googleId, 0);
        this.setState({ register });
        this.googleButtonOpacityToggle();
        this.updateValidation();
    }

    googleButtonOpacityToggle = () => {
        let googleButtonFaded = this.state.googleButtonFaded;
        googleButtonFaded = !googleButtonFaded;
        this.setState({ googleButtonFaded });
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    componentDidMount() {
        
    }

    handleBillingAddressChange = (value) => {
        const register = {...this.state.register};
        const { validation } = this.state;
        register.business.billing_address_1 = value;
        validation['business']['billing_address_1']['valid'] = value !== '';
        this.setState({
            register,
            validation
        }, () => {
            this.validateAllRequiredFields();
        });
    }

    handleFullBillingAddressChange = (value) => {
        const { register } = this.state;
        const { validation } = this.state;
        register['business']['billing_address_1'] = `${value.address}`;
        register['business']['billing_city'] = `${value.city}`;
        register['business']['billing_country'] = `${value.country}`;
        register['business']['billing_state'] = `${value.state}`;
        register['business']['billing_zip'] = `${value.zip}`;
        validation['business']['billing_address_1']['valid'] = true;
        validation['business']['billing_city']['valid'] = true;
        validation['business']['billing_country']['valid'] = true;
        validation['business']['billing_state']['valid'] = true;
        validation['business']['billing_zip']['valid'] = true;
        this.setState({
            register,
            validation
        }, () => {
            this.validateAllRequiredFields();
        });
        console.log(value);
    }

    render() {
        return (
            <form>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                <ClientSignup 
                    register={this.state.register} 
                    handleChange={this.handleChange}
                    handleBillingAddressChange={this.handleBillingAddressChange}
                    handleFullBillingAddressChange={this.handleFullBillingAddressChange}
                    validateRequiredField={this.validateRequiredField}
                    validation={this.state.validation} 
                />
                <AdminInformation 
                    register={this.state.register} 
                    handleChange={this.handleChange} 
                    validateRequiredField={this.validateRequiredField}
                    validation={this.state.validation} 
                    facebookCallback={this.facebookCallback}
                    googleCallback={this.googleCallback}
                    googleButtonFaded={this.state.googleButtonFaded}
                    googleButtonOpacityToggle={this.state.googleButtonOpacityToggle}
                />
                <Options 
                    register={this.state.register} 
                    handleChange={this.handleChange}
                />
                <Disclaimer 
                    validation={this.state.validation}
                    isReadyToSubmit={this.state.isReadyToSubmit}
                    postUser={this.postUser}    
                />
            </form>
        );
    }
}

export default Registration;



// WEBPACK FOOTER //
// ./src/components/Registration/Registration.js